import { HeaderBar, ScreenLoader, UI_STYLES  } from "@/components/ui";
import { motion } from "framer-motion";
import { LuckyCardFree } from "./ui/LuckyCardFree";
import { useLuckyCardScreenViewModel } from "./LuckyCardScreenViewModel";
import LuckyCardPremium from "./ui/LuckyCardPremium";
import { Helmet } from "react-helmet-async";

export function LuckyCardScreen() {
  const {
    navigateToHome,
    onSelectCard,
    isLoading,
    onSubscriptionClick,
    onTelegramClick,
    isSubscribed,
    deck,
    luckyCard,
    resetDate,
    statistics,
  } = useLuckyCardScreenViewModel();

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.3, ease: "easeInOut" }}
      className={`h-full ${UI_STYLES.backgroundDarkBlue} `}
    >
      <Helmet>
        <title>Счастливая карта Таро | Мир Звёзд</title>
        <meta name="description" content="Угадайте свою счастливую карту Таро и получите персональное предсказание. Еженедельная возможность выбрать карту из колоды и узнать, что она означает для вас. Толкование карт Таро от профессиональных астрологов." />
        <meta name="keywords" content="счастливая карта, карты таро, гадание на картах, предсказание, толкование карт, таро, астрология, гадание, мистика" />
        <meta name="author" content="bpTech" />
        <meta name="robots" content="index, follow" />
        <meta property="og:title" content="Счастливая карта Таро | Мир Звёзд" />
        <meta property="og:description" content="Угадайте свою счастливую карту Таро и получите персональное предсказание. Еженедельная возможность выбрать карту из колоды." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://мир-звезд.рф/lucky-card" />
      </Helmet>
      <ScreenLoader isLoading={isLoading} />
      <HeaderBar title="Счастливая карта" onBack={navigateToHome} />
      <div
        className={`flex flex-col items-center max-w-xl mx-auto h-full`} 

      >
        {isSubscribed ? (
          <LuckyCardPremium
            cards={deck}
            luckyCard={luckyCard}
            resetDate={resetDate}
            onSelectCard={onSelectCard}
          />
        ) : (
          <LuckyCardFree
            onSubscriptionClick={onSubscriptionClick}
            onTelegramClick={onTelegramClick}
            statistics={statistics}
          />
        )}
      </div>
    </motion.div>
  );
}
export default LuckyCardScreen;
